import { render } from "./ClientPersonalEditar.vue?vue&type=template&id=2523cd0b"
import script from "./ClientPersonalEditar.vue?vue&type=script&lang=js"
export * from "./ClientPersonalEditar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__